<template>
    <div class="rightCon">
        <monitor-echarts-two></monitor-echarts-two>
        <monitor-echarts-one></monitor-echarts-one>
        <monitor-right-carousel></monitor-right-carousel>
        <monitor-news></monitor-news>
    </div>
</template>

<script>
import MonitorEchartsTwo from './MonitorEchartsTwo'
import MonitorRightCarousel from './MonitorRightCarousel'
import MonitorEchartsOne from './MonitorEchartsOne'
import MonitorNews from './MonitorNews'

export default {
    name: 'MonitorRight',
    components: {
        MonitorEchartsTwo,
        MonitorEchartsOne,
        MonitorRightCarousel,
        MonitorNews,
    },
    data() {
        return {}
    },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorRight.vue